<template>
  <div :class="wrapper">
    <div class="mdc-text-field" :class="classes">
      <i v-if="!!hasLeadingIcon"
         ref="icon"
         tabindex="-1"
         class="mdc-text-field__icon">
      <slot name="leading-icon"/>
      </i>
      <input class="mdc-text-field__input"
            :value="value"
            v-bind="$attrs"
            autocomplete="new-password"
            :type="type"
            @input="$emit('model', $event.target.value)"
            :placeholder="pHolder"
            :name="'input-' + Date.now()"
            :id="'input-' + Date.now()"
            >
      <i v-if="!!hasTrailingIcon"
        ref="icon"
        tabindex="-1"
        class="mdc-text-field__icon">
        <slot name="trailing-icon"/>
      </i>
      <div v-if="outlined" class="mdc-notched-outline">
        <div class="mdc-notched-outline__leading"></div>
        <div class="mdc-notched-outline__notch">
          <label v-if="label" for="input" class="mdc-floating-label">{{label}}</label>
        </div>
        <div class="mdc-notched-outline__trailing"></div>
      </div>
      <label v-if="!outlined && !fullwidth && label" for="input" class="mdc-floating-label">{{label}}</label>
      <div v-if="!outlined && !fullwidth" class="mdc-line-ripple"></div>
    </div>
    <div class="mdc-text-field-helper-line">
      <mdc-body typo="body2" v-if="helptext" class="sub-label">{{helptext}}</mdc-body>
      <slot v-if="hasCounter" name="counter"/>
    </div>
  </div>
</template>

<script>
import { MDCTextField } from '@material/textfield'

export default {
  name: 'mdc-text-field',
  model: {
    prop: 'value',
    event: 'model'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    upgraded: {
      type: Boolean,
      default: false
    },
    fullwidth: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    helptext: {
      type: String
    },
    autocomplete: {
      type: String,
      default: 'new-password'
    }
  },
  data () {
    return {
      textField: undefined
    }
  },
  computed: {
    wrapper () {
      return {
        'mdc-textfield-wrapper': !this.fullwidth
      }
    },
    classes () {
      return {
        'mdc-text-field--outlined': this.outlined,
        'mdc-text-field--fullwidth': this.fullwidth,
        'mdc-text-field--disabled': this.disabled,
        'mdc-text-field--dense': this.dense,
        'mdc-text-field--with-leading-icon': this.$slots['leading-icon'],
        'mdc-text-field--with-trailing-icon': this.$slots['trailing-icon'],
        'mdc-text-field--no-label': (!(this.Label === undefined) || this.fullwidth)
      }
    },
    hasLeadingIcon () {
      if (this.$slots['leading-icon']) return true
      return false
    },
    hasTrailingIcon () {
      if (this.$slots['trailing-icon']) return true
      return false
    },
    hasCounter () {
      if (this.$slots['counter']) return true
      return false
    },
    pHolder () {
      if (this.placeholder) {
        return this.placeholder
      } else {
        if (this.fullwidth) {
          return this.label
        } else {
          return ''
        }
      }
    }
  },
  watch: {
    disabled () {
      this.textField.disabled = this.disabled
    }
  },
  mounted () {
    this.textField = MDCTextField.attachTo(this.$el.querySelector('.mdc-text-field'))
    this.textField.disabled = this.disabled
  }
}
</script>

<style>
.mdc-text-field.mdc-text-field--outlined {
  height: 54px;
}

.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-text-field__icon {
  top: 8px;
  right: initial;
  left: 8px;
}

.mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__notch {
  width:auto !important;
  margin-right:-2%;
}

.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above, .mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above {
  margin-left: 6px;
  margin-right: -12px;
}

.mdc-text-field:not(.mdc-text-field--disabled):not(.mdc-text-field--outlined):not(.mdc-text-field--textarea) .mdc-text-field__input {
  height: 36px;
  margin-left: 16px;
}

.mdc-text-field:not(.mdc-ripple-upgraded):focus::before, .mdc-text-field.mdc-ripple-upgraded--background-focused::before {
    transition-duration: 75ms;
    opacity: .04;
}

.mdc-text-field--with-leading-icon .mdc-text-field__icon {
  bottom: 10px;
}
.mdc-text-field--with-trailing-icon .mdc-text-field__icon {
  bottom: 10px;
}

.mdc-text-field--with-leading-icon .mdc-text-field__icon .mdc-icon.error {
  color: #b00020;
}
.mdc-text-field--with-trailing-icon .mdc-text-field__icon .mdc-icon.error {
  color: #b00020;
}
.mdc-text-field.mdc-text-field--dense {
  height:42px;
  margin-top:0px;
}
</style>
